import { Component, inject, input, output, signal, ElementRef, HostListener, computed, effect } from '@angular/core';
import { provideIcons } from '@ng-icons/core';
import { heroXMark } from '@ng-icons/heroicons/outline';
import { IconComponent } from 'app/shared/icon/icon.component';

@Component({
  selector: 'app-inline-dialog',
  standalone: true,
  imports: [IconComponent],
  templateUrl: './inline-dialog.component.html',
  styles: ``,
  providers: [provideIcons({ heroXMark })],
  host: {
    '[class]': 'openedClass()',
  },
})
export class InlineDialogComponent {
  checkBeforeClosing = input(false);
  noCloseIcon = input(false);
  opened = input(false);
  openedChange = output<boolean>();
  openedClass = computed(
    () =>
      'overflow-auto min-h-[650px] absolute bg-white rounded-t-2xl shadow z-10 top-6 right-0 lg:w-[900px] md:w-[500px] ' +
      (this.opened() ? 'block' : 'hidden'),
  );

  private elementRef = inject(ElementRef);
  outsideClickActive = false;

  constructor() {
    effect(() => {
      if (this.opened()) {
        // wait for the dialog to be fully opened
        setTimeout(() => {
          this.outsideClickActive = true;
        }, 100);
      } else {
        this.outsideClickActive = false;
        this.close();
      }
    });
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this.opened() || !this.outsideClickActive) return;
    const dialogElement = this.elementRef.nativeElement;
    const path = (event.composedPath && event.composedPath()) || [];
    const overlayContainer = document.querySelector('.cdk-overlay-container');
    if (path.includes(dialogElement) || (overlayContainer && path.includes(overlayContainer))) {
      // Click was inside the dialog or a material overlay
      return;
    }
    this.close();
  }

  close() {
    this.outsideClickActive = false;
    this.openedChange.emit(false);
  }
}
